import { get, post } from '@tovala/browser-apis-combinedapi'

export interface CreateMealReviewRequest {
  data: {
    comment: string
    mealid: number
    menuProductID?: string
    platform: string
    rating: number
    ratingType: string
    routineRevisionID: null
    selectedChipIDs: string[]
    sharePublicly?: boolean
    userid: number
  }
}

export interface CreateMealReviewResponse {
  ID: string
}

export interface RatingChip {
  displayOrder: number
  id: string
  maxRating: number
  minRating: number
  name: string
}

export interface RatingChips {
  chips: RatingChip[]
  schemaVersion: string
}

export type GetRatingChipsResponse = RatingChips

export const ENDPOINTS = {
  CREATE_MEAL_REVIEW: () => ({
    path: '/cookablereviews',
    version: 'v1' as const,
  }),
  GET_RATING_CHIPS: () => ({
    path: '/ratingChips',
    version: 'v2' as const,
  }),
}

export async function createMealReview({ data }: CreateMealReviewRequest) {
  return post<CreateMealReviewResponse>({
    data,
    ...ENDPOINTS.CREATE_MEAL_REVIEW(),
  })
}

export async function getRatingChips() {
  return get<GetRatingChipsResponse>(ENDPOINTS.GET_RATING_CHIPS())
}
